import React, { Component } from 'react';
import { Dropdown, Label, Popup, Icon } from 'semantic-ui-react'
import DatePicker from 'react-datepicker';

class ActionStatusRenderer extends Component {
  constructor(props){
    super(props);

    this.state = {
      showDatePicker: false,
    }
  }

  onStatusSelection = (data) => {
    this.props.changeHanler({
      dueDate: this.props.details.dueDate,
      status: data.value,
    })
  }

  onDateSelection = (date) => {
    this.setState({
      showDatePicker: false,
    })
    this.props.changeHanler({
      dueDate: date.format("DD MMM YYYY"),
      status: this.props.details.status,
    })
  }

  toggleCalendar = (show) => {
    this.setState({showDatePicker: show})
  }

  render() {
    const { open, in_progress, complete } = this.props.translations
    const statusOptions = [
      { text: open, value: "Open" },
      { text: in_progress, value: "In Progress" },
      { text: complete, value: "Complete" },
    ]

    const datepicker = (
      <div>
        {
          this.state.showDatePicker &&
          <DatePicker
            onChange={ (date) => this.onDateSelection(date) }
            inline
            showYearDropdown
            showMonthDropdown
            useShortMonthInDropdown
            yearDropdownItemNumber={3}
          />
        }
      </div>
    )

    const { due_date, status, select_status } = this.props.translations
    const can_update = this.props.permission.can_update
    return (
      <div>
        <Label>
          <div>
            <Label size='medium'>{due_date + ':'}</Label>
            <Label size='medium'>{ this.props.details.dueDate }</Label>
            <Popup
              trigger={ <Icon className={ can_update ? '' : 'readonly'} name='calendar alternate' link circular inverted bordered/> }
              content= { datepicker }
              onOpen={ () => this.toggleCalendar(true) }
              onClose={ () => this.toggleCalendar(false) }
              on='click'
              position="bottom left"
              basic
              hoverable
              flowing
            />
          </div>
          <br />
          <div>
            <Label size='medium'>{status + ':'}</Label>
            <Dropdown
              className={can_update ? '' : 'readonly'}
              placeholder={select_status}
              selection
              options={ statusOptions }
              defaultValue={ this.props.details.status }
              onChange={ (evt, data) => this.onStatusSelection(data) }
            />
          </div>
        </Label>
      </div>
    );
  }
}

export default ActionStatusRenderer;



// WEBPACK FOOTER //
// ./src/components/action_status_renderer.js